import { Alert } from "~/common/m3/Alert/Alert";
import { userIsLoggedIn } from "../../../utils/roles";
import { canSeeCountryOrigin } from "../../../utils/siteModes";
import { useTranslation } from "react-i18next";
import ParagraphWithShowAll from "../ParagraphWithShowAll/ParagraphWithShowAll";

export interface Props {
  className?: string;
  disabled?: boolean;
  show?: boolean;
}

const DisclaimerCountryOrigin = ({
  className,
  disabled = false,
  show = userIsLoggedIn() && canSeeCountryOrigin,
}: Props) => {
  const { t } = useTranslation();
  return show && !disabled ? (
    <Alert severity={"info"} className={`scha__disclaimer__country-of-origin ${className ?? ""}`}>
      <div data-test-id={"disclaimer-country-of-origin"}>
        <ParagraphWithShowAll paragraph={t("common.countryOfOrigin.disclaimer")} />
      </div>
    </Alert>
  ) : null;
};

export default DisclaimerCountryOrigin;
